import React from 'react';
import classnames from '@src/helpers/classnames';
import {IModelFileToImportModel} from '@src/@interfaces/models/ModelFileToImport/IModelFileToImportModel';
import {useFormContext, useWatch} from 'react-hook-form';
import {TForm} from '@src/components/_views/configurable/import-view/file-list/.types';
import ColumnField from '@src/components/_views/configurable/import-view/file-list/additional-row/table/ColumnField';
import {IImportConfig} from '@src/@interfaces/components/Import/IImportConfig';

export default function Table(props: {
    model?: IModelFileToImportModel,
    config: IImportConfig,
    columns: any[],
    data?: Array<string[]>,
}) {
    const {model, columns, data, config} = props;

    const {control} = useFormContext<TForm>();
    const skipFirstRows = useWatch({name: 'skipFirstRows', control}) ?? 0;

    if (!data) {
        return null;
    }

    return <div className="table-responsive">
        <table className="table table-bordered rounded">
            <thead>
                <tr>
                    {columns.map((_, i) => {
                        return <td key={`${model?.id}@th-${i}`}>
                            <ColumnField
                                    rowIndex={0}
                                    columnIndex={i}
                                    config={config}
                            />
                        </td>;
                    })}
                </tr>
            </thead>
            <tbody>
                {data?.map((cells, i) => {
                    const isSkipped = skipFirstRows > i;

                    return <tr key={`${model?.id}@${i}`} className={classnames({
                        'opacity-25': isSkipped,
                    })}>
                        {columns.map((_, j) => {
                            const value = cells[j] ?? null;

                            return <td key={`${model?.id}@${j}`}>
                                {value}
                            </td>;
                        })}
                    </tr>;
                })}
            </tbody>
        </table>
    </div>;
}
